import React from 'react'
import { IonPage, IonContent, IonButton } from '@ionic/react'
import Header from '../../components/Header'
import Input from '../../components/Input'

import { PassHideIcon, PassShowIcon, UserIcon } from '../../conf/images'

import './index.css'
import Toast, { ToastProps } from '../../components/Toast'
import { changePassword } from '../../service/api/user'
import { useHistory } from 'react-router'
import { HomePage } from '../../conf/routePath'

const Password: React.FC<{}> = () => {
    const history = useHistory()
    const [oldPassword, setOldPassword] = React.useState({
        passShow: false,
        password: '',
    })
    const [newPassword, setNewPassword] = React.useState({
        passShow: false,
        password: '',
    })
    const [repeatPassword, setRepeatPassword] = React.useState({
        passShow: false,
        password: '',
    })

    const [toastOptions, setToastToastOptions] = React.useState<ToastProps>({
        isOpen: false,
        message: '',
        position: 'top',
        color: 'error',
        duration: 1500,
    })

    const isDisabled = () => {
        return !(
            oldPassword.password &&
            newPassword.password &&
            repeatPassword.password
        )
    }
    const errorToast = (msg: string) => {
        setToastToastOptions((v) => ({
            ...v,
            isOpen: true,
            position: 'middle',
            message: msg,
        }))
    }

    const submit = () => {
        changePassword(oldPassword.password, newPassword.password)
            .then((res) => {
                setToastToastOptions((v) => ({
                    ...v,
                    isOpen: true,
                    position: 'middle',
                    color: 'success',
                    message: '修改成功',
                }))
                history.push(HomePage)
            })
            .catch((e) => {
                errorToast(e.message)
            })
    }

    const verifyPassword = () => {
        const verifyLen = () => {
            errorToast('密码长度限制为 6 - 16 位')
        }

        if (
            oldPassword.password.length < 6 ||
            oldPassword.password.length > 16
        ) {
            return verifyLen()
        }

        if (
            newPassword.password.length < 6 ||
            newPassword.password.length > 16
        ) {
            return verifyLen()
        }
        if (newPassword.password !== repeatPassword.password) {
            return errorToast('两次输入的密码不相等')
        }
        submit()
    }
    return (
        <IonPage>
            <IonContent className='mybot-content'>
                <Header title='修改密码' backable />
                <div className='passwordProfile'>
                    <img src={UserIcon} alt='profile' />
                </div>

                <div>
                    <div className='passwordInputBox'>
                        <Input
                            type={oldPassword.passShow ? 'text' : 'password'}
                            className='input password'
                            value={oldPassword.password}
                            onChange={(val) =>
                                setOldPassword((v) => ({
                                    ...v,
                                    password: val,
                                }))
                            }
                            suffix={
                                <img
                                    className='pass-switch'
                                    onClick={() =>
                                        setOldPassword((v) => ({
                                            ...v,
                                            passShow: !oldPassword.passShow,
                                        }))
                                    }
                                    src={
                                        oldPassword.passShow
                                            ? PassHideIcon
                                            : PassShowIcon
                                    }
                                    alt='icon'
                                />
                            }
                            placeholder='请输入旧密码'
                        />
                    </div>
                    <div className='passwordInputBox'>
                        <Input
                            type={newPassword.passShow ? 'text' : 'password'}
                            className='input password'
                            value={newPassword.password}
                            onChange={(val) =>
                                setNewPassword((v) => ({
                                    ...v,
                                    password: val,
                                }))
                            }
                            suffix={
                                <img
                                    className='pass-switch'
                                    onClick={() =>
                                        setNewPassword((v) => ({
                                            ...v,
                                            passShow: !newPassword.passShow,
                                        }))
                                    }
                                    src={
                                        newPassword.passShow
                                            ? PassHideIcon
                                            : PassShowIcon
                                    }
                                    alt='icon'
                                />
                            }
                            placeholder='请输入新的密码'
                        />
                    </div>
                    <div className='passwordInputBox'>
                        <Input
                            type={repeatPassword.passShow ? 'text' : 'password'}
                            className='input password'
                            value={repeatPassword.password}
                            onChange={(val) =>
                                setRepeatPassword((v) => ({
                                    ...v,
                                    password: val,
                                }))
                            }
                            suffix={
                                <img
                                    className='pass-switch'
                                    onClick={() =>
                                        setRepeatPassword((v) => ({
                                            ...v,
                                            passShow: !repeatPassword.passShow,
                                        }))
                                    }
                                    src={
                                        repeatPassword.passShow
                                            ? PassHideIcon
                                            : PassShowIcon
                                    }
                                    alt='icon'
                                />
                            }
                            placeholder='请再次输入新密码'
                        />
                    </div>
                    <div className='passwordBtnBox'>
                        <IonButton
                            onClick={verifyPassword}
                            expand='full'
                            disabled={isDisabled()}
                        >
                            确认
                        </IonButton>
                    </div>
                </div>
                <Toast
                    {...toastOptions}
                    onClose={() =>
                        setToastToastOptions({ ...toastOptions, isOpen: false })
                    }
                />
            </IonContent>
        </IonPage>
    )
}

export default Password
